import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiAreaChart = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M3 20V7L7 10L12 3L17 7H21V20H3ZM8 17L12 11.5L19 16.95V9H16.3L12.4 5.875L7.45 12.825L5 11V14.6L8 17Z"/>
  </SvgWrapper>
)
